import { render, staticRenderFns } from "./AuthTabs.vue?vue&type=template&id=4fa03818&scoped=true"
import script from "./AuthTabs.vue?vue&type=script&lang=js"
export * from "./AuthTabs.vue?vue&type=script&lang=js"
import style0 from "./AuthTabs.vue?vue&type=style&index=0&id=4fa03818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa03818",
  null
  
)

export default component.exports